import { Box, Grid } from "@mui/material";
import { useFormik } from "formik";
import * as Yup from "yup";
import { LoadingButton } from "@mui/lab";
import FormikControl from "../../common/FormikControl";
import { useDispatch } from "react-redux";
import { printForQR } from "../../../slices/QRCode";

const PrintForm = ({ qrCodeId, handleCloseModal, handlePrint ,getTimeLine}) => {
  const dispatch = useDispatch();

  const initialValues = {
    bags: ""
  }

  const validationSchema = Yup.object().shape({
    bags: Yup.number()
      .transform((value, originalValue) => {
        return originalValue === '' ? undefined : Number(originalValue);
      })
      .typeError("Must be a valid number")
      .min(2, "Number must be at least 2")
      .max(5, "Number must be less than or equal to 5")
      .required("This is a required field")
  });

  const handleSubmit = async (values, { setSubmitting }) => {
    try {

      let payload = {
        ...values,
        id: qrCodeId
      }
      const printQR = await dispatch(printForQR(payload)).unwrap();
      if (printQR.success) {
        handlePrint({ bags: values?.bags });
        getTimeLine()
      }
    } catch (err) {
      console.error(err);
    } finally {
      formik.handleReset()
      setSubmitting(false);
      handleCloseModal();
    }
  }

  const formik = useFormik({
    initialValues,
    validationSchema,
    onSubmit: handleSubmit
  })

  const formOptions = [
    {
      label: 'Number of Bags',
      type: 'number',
      min: 1,
      name: 'bags',
      required: true,
      placeholder: 'Enter number'
    }
  ]

  return (
    <Box>
      <form onSubmit={formik.handleSubmit}>
        <Grid container spacing={2} className="mb-3">
          {formOptions.map((props, key) => (
            <Grid key={key} item xs={12}>
              <FormikControl formik={formik} {...props} />
            </Grid>
          ))}
        </Grid>
        <Grid container spacing={2} className="pt-2 pb-2">
          <Grid item xs={12}>
            <LoadingButton fullWidth type="submit" variant="contained" loading={formik.isSubmitting} disabled={formik.isSubmitting}>Submit</LoadingButton>
          </Grid>
        </Grid>
      </form>
    </Box>
  );
}

export default PrintForm;